import { useEffect, useMemo, useState } from "react";
import services from "../../../services/services";
import { Urls } from "../../../services/Urls";
import _ from "underscore";

export const useCommanKit = ({ data }) => {

    const [signature, setSignature] = useState({});


    const handleChange = (e) => {
        const { name } = e.target
        const file = e.target?.files?.[0];
        if (file) {
            setSignature(prev => ({
                ...prev,
                [name]: file
            }));
        }
    }

    const handleRemove = (e) => {
        setSignature(prev => ({
            ...prev,
            [e]: ''
        }));
    };

    const getEmployeeDetails = async (key, user_code) => {
        try {
            const payload = {
                "compliance_type": key,
                "requested_user_code": user_code
            }
            const res = await services.getInvokeRemote("POST", Urls("GETEMPLOYEECOMPLIANCEDATA"), payload)
            if (res?.status === 200 && !_.isEmpty(res?.body?.data)) {
                return res?.body?.data
            }
        } catch (error) {
            console.error('Error :', error);
        }
    }


    useEffect(() => {
        setSignature((prev) => ({
            ...prev,
            user_signature_url: data.commonDetails?.user_signature_url,
            hr_sign: data?.hrSignature?.user_signature_file_id
        }))
    }, [data.commonDetails, data?.hrSignature])

    return useMemo(() => ({
        signature, handleChange, getEmployeeDetails, handleRemove
    }), [signature, handleChange, getEmployeeDetails, handleRemove])
}
